<template>
  <div class="history-page padding-lr-30">
    <common-header />
    <div class="bg-white padding-bottom-30" style="">
      <section class="history-content bg-white margin-top-25">
        <div class="padding-tb-30">
          <i class="el-icon-arrow-left text-bold" @click="$router.back()"></i>
          <span class="text-21-color text-bold padding-left-10">草稿箱</span>
        </div>
        <el-table
          :data="records"
          border
          class="history-table"
          header-row-class-name="history-table__header"
          :cell-style="bodyCellStyle"
          :header-cell-style="headerCellStyle"
          :row-class-name="'history-row'"
          v-loading="loading"
        >
          <el-table-column prop="id" label="序号" width="80" align="center" />
          <el-table-column prop="title" label="作品信息" align="center" />
          <el-table-column
            prop="date"
            label="日期"
            width="160"
            align="center"
          />
          <el-table-column
            prop="platform"
            label="平台"
            width="120"
            align="center"
          />
          <el-table-column
            prop="status_text"
            label="状态"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span
                :class="[
                  'status-pill',
                  scope.row.status === 'pending' ? 'pending' : 'success',
                ]"
              >
                {{ scope.row.status_text }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="mail_send_interval_minutes"
            label="投稿频率"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.mail_send_interval_minutes || 1 }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="360" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="action-link"
                @click="
                  handleAction(
                    scope.row.status === 'pending' ? 'start' : 'view',
                    scope.row
                  )
                "
              >
                {{ scope.row.status === "pending" ? "开始投稿" : "查看投稿" }}
              </el-button>
              <el-button
                type="text"
                class="action-link"
                @click="handleAction('edit', scope.row)"
                >修改</el-button
              >
              <el-button
                type="text"
                class="action-link"
                @click="handleAction('delete', scope.row)"
                >删除</el-button
              >
              <el-button
                type="text"
                class="action-link"
                @click="handleAction('detail', scope.row)"
                >查看详情</el-button
              >
              <el-button
                type="text"
                class="action-link"
                @click="handleAction('frequency', scope.row)"
                >投稿频率设置</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="history-pagination" v-if="total > 0">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="page"
            :page-size="limit"
            :total="total"
            @current-change="handlePageChange"
          />
        </div>
      </section>
    </div>
    <el-dialog
      :visible.sync="confirmVisible"
      width="420px"
      top="30vh"
      custom-class="history-dialog"
      :show-close="false"
    >
      <template #title>
        <div class="text-center text-21-color">提示</div>
      </template>
      <div class="text-center text-bold text-000-color">
        确认{{ confirmType === "start" ? "投稿" : "删除" }}吗？
      </div>
      <span
        slot="footer"
        class="dialog-footer padding-top-100 padding-bottom-40"
      >
        <el-button
          class="dialog-btn ghost"
          @click="cancelConfirm"
          :disabled="emailLoading"
          >取消</el-button
        >
        <el-button
          class="dialog-btn solid"
          type="primary"
          @click="confirmSubmit"
          :loading="emailLoading"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <!-- 投稿频率设置弹窗 -->
    <el-dialog
      :visible.sync="frequencyDialogVisible"
      width="420px"
      top="30vh"
      custom-class="frequency-dialog"
      :show-close="false"
    >
      <template #title>
        <div class="text-center text-21-color">投稿频率设置</div>
      </template>
      <div class="padding-lr-40">
        <el-input
          v-model.trim="frequencyMinutes"
          type="number"
          placeholder="请输入分钟"
          min="1"
          max="5"
        >
          <template slot="append">分钟</template>
        </el-input>
      </div>
      <span
        slot="footer"
        class="dialog-footer padding-top-30 padding-bottom-30"
      >
        <el-button class="dialog-btn ghost" @click="closeFrequencyDialog"
          >取消</el-button
        >
        <el-button
          class="dialog-btn solid"
          type="primary"
          :loading="frequencyLoading"
          @click="saveFrequency"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <!-- 授权邮箱弹窗 -->
    <el-dialog
      :visible.sync="emailAuthDialogVisible"
      width="1280px"
      custom-class="email-auth-dialog"
      :show-close="false"
      :close-on-click-modal="true"
    >
      <template #title>
        <div class="email-auth-title text-center text-bold">授权邮箱编辑</div>
      </template>
      <div class="email-auth-content">
        <div class="email-auth-tip text-14 text-999-color">
          最多可设置 {{ maxEmailCount }} 个邮箱<span
            class="text-14 text-999-color"
            >(仅支持QQ邮箱)</span
          >
        </div>
        <div
          class="email-auth-form"
          v-for="(item, index) in emailAuthList"
          :key="item.id || `new-${index}`"
        >
          <div class="email-auth-form-row flex align-center">
            <div class="email-auth-field flex align-center">
              <label class="email-auth-label padding-right-4">邮箱</label>
              <el-input
                v-model.trim="item.email"
                placeholder="请输入邮箱"
                class="email-auth-input"
              />
            </div>
            <div class="email-auth-field flex align-center">
              <label class="email-auth-label padding-right-4">授权码</label>
              <el-input
                v-model.trim="item.auth_code"
                placeholder="请输入授权码（不修改可留空）"
                class="email-auth-input"
              />
            </div>
            <div class="email-auth-field flex align-center">
              <label class="email-auth-label padding-right-4">笔名</label>
              <el-input
                v-model.trim="item.penName"
                placeholder="请输入笔名"
                class="email-auth-input"
              />
            </div>
            <div class="email-auth-actions flex align-center">
              <el-button
                size="mini"
                :type="item.isDefault === '1' ? 'primary' : 'default'"
                @click="handleSetDefaultEmail(item)"
              >
                {{ item.isDefault === "1" ? "默认邮箱" : "设为默认" }}
              </el-button>
              <el-button
                size="mini"
                type="danger"
                plain
                @click="handleDeleteEmail(item, index)"
              >
                删除
              </el-button>
            </div>
          </div>
        </div>
        <div class="email-auth-add-row">
          <el-button
            size="mini"
            plain
            class="email-auth-add-btn"
            :disabled="emailAuthList.length >= maxEmailCount"
            @click="addEmailAuthRow"
          >
            + 新增邮箱
          </el-button>
        </div>
      </div>
      <div slot="footer" class="email-auth-footer text-center">
        <div
          class="text-14 padding-bottom-20 text-main"
          @click="handleEmailAuthorizationCodeTutorial"
        >
          获取邮箱授权码教程
        </div>
        <el-button
          class="email-auth-save-btn"
          :loading="emailAuthLoading"
          @click="handleEmailAuthSave"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue";
import {
  getSubmissionList,
  deleteSubmission,
  sendEmail,
  updateSendInterval,
} from "@/api/submission";
import {
  getUserInfo,
  getSenderEmailList,
  addSenderEmail,
  editSenderEmail,
  setDefaultSenderEmail,
  deleteSenderEmail,
} from "@/api/user";

export default {
  name: "History",
  components: { CommonHeader },
  data() {
    return {
      records: [],
      loading: false,
      page: 1,
      limit: 10,
      total: 0,
      confirmVisible: false,
      confirmTarget: null,
      confirmType: "",
      emailLoading: false,
      frequencyDialogVisible: false,
      frequencyMinutes: "",
      frequencyTarget: null,
      frequencyLoading: false,
      userInfo: {},
      emailAuthDialogVisible: false,
      emailAuthList: [],
      emailAuthLoading: false,
      maxEmailCount: 3,
      pendingSubmissionRow: null, // 保存待投稿的行数据
    };
  },
  mounted() {
    this.fetchSubmissionList();
    this.fetchUserInfo();
  },
  methods: {
    // 获取用户信息
    fetchUserInfo() {
      return getUserInfo()
        .then((response) => {
          if (response.data) {
            this.userInfo = response.data;
          }
          return response;
        })
        .catch((error) => {
          if (error.message && !error.message.includes("请登录后操作")) {
            console.error("获取用户信息失败:", error);
          }
          throw error;
        });
    },
    // 获取投稿列表
    fetchSubmissionList() {
      this.loading = true;
      getSubmissionList({
        page: this.page.toString(),
        limit: this.limit.toString(),
      }).then((response) => {
        this.loading = false;
        const payload = response.data || {};
        this.total =
          Number(payload.total ?? payload.total_count ?? payload.count) || 0;
        if (payload && payload.list && Array.isArray(payload.list)) {
          this.records = payload.list.map((item) => {
            let date = "";
            if (item.createtime) {
              const dateObj = new Date(item.createtime * 1000);
              const year = dateObj.getFullYear();
              const month = String(dateObj.getMonth() + 1).padStart(2, "0");
              const day = String(dateObj.getDate()).padStart(2, "0");
              const hours = String(dateObj.getHours()).padStart(2, "0");
              const minutes = String(dateObj.getMinutes()).padStart(2, "0");
              date = `${year}-${month}-${day}   ${hours}:${minutes}`;
            }

            let platform = "未知平台";
            if (
              item.platforms &&
              Array.isArray(item.platforms) &&
              item.platforms.length > 0
            ) {
              platform = item.platforms.join("、");
            } else if (item.platform_name) {
              platform = item.platform_name;
            } else if (item.platform) {
              platform = item.platform;
            }

            return {
              id: item.id,
              title: item.title || "未命名作品",
              date: date,
              platform: platform,
              status_text: item.status_text,
              status: item.status,
              mail_send_interval_minutes:
                Number(item.mail_send_interval_minutes) || 0,
              rawData: item,
            };
          });
        } else if (payload && Array.isArray(payload)) {
          this.records = payload.map((item) => ({
            id: item.id,
            title: item.title || "未命名作品",
            date: item.date || "",
            platform: item.platform || "未知平台",
            status: item.status || "未投稿",
            mail_send_interval_minutes:
              Number(item.mail_send_interval_minutes) || 0,
            rawData: item,
          }));
          this.total = this.records.length;
        }
      });
    },
    handlePageChange(page) {
      this.page = page;
      this.fetchSubmissionList();
    },
    handleAction(type, row) {
      // 如果是开始投稿，先判断是否会员；非会员再校验免费投稿次数
      if (type === "start") {
        if (this.userInfo.is_member == false) {
          this.$message.warning("请开通会员后继续投稿");
          return;
        }
        // 检查是否有授权码
        if (!this.userInfo.auth_code) {
          // 打开授权邮箱对话框
          this.handleEmailCode();
          // 保存当前要投稿的行数据，保存授权码后继续投稿
          this.pendingSubmissionRow = row;
          return;
        }
      }

      if (["start", "delete"].includes(type)) {
        this.confirmType = type;
        this.confirmTarget = row;
        this.confirmVisible = true;
        return;
      }
      if (type === "frequency") {
        this.frequencyTarget = row;
        const source = row.rawData || row;
        const minutes =
          source.mail_send_interval_minutes ||
          source.submit_frequency_minutes ||
          source.frequency_minutes ||
          "";
        this.frequencyMinutes = minutes ? String(minutes) : "";
        this.frequencyDialogVisible = true;
        return;
      }
      if (type === "view" && this.$router) {
        const id = row.rawData ? row.rawData.id : row.id;
        this.$router.push({
          path: "/status",
          query: { id: id },
        });
      } else if (type === "detail" && this.$router) {
        const id = row.rawData ? row.rawData.id : row.id;
        this.$router.push({
          path: "/status/detail",
          query: { id: id },
        });
      } else if (type === "edit" && this.$router) {
        const id = row.rawData ? row.rawData.id : row.id;
        this.$router.push({
          path: "/quick-submit",
          query: { id: id },
        });
      } else {
        this.$message.info(
          `${type === "edit" ? "修改记录" : "查看详情"}：${row.title}`
        );
      }
    },
    confirmSubmit() {
      if (this.confirmType === "delete") {
        const id = this.confirmTarget.rawData
          ? this.confirmTarget.rawData.id
          : this.confirmTarget.id;
        if (!id) {
          this.$message.error("无法获取投稿ID");
          this.confirmVisible = false;
          return;
        }
        deleteSubmission(id)
          .then((response) => {
            this.$message.success("删除成功");
            this.confirmVisible = false;
            this.fetchSubmissionList();
          })
          .catch((error) => {
            this.$message.error(error.message || "删除失败，请稍后重试");
            this.confirmVisible = false;
          });
      } else if (this.confirmType === "start") {
        const row = this.confirmTarget;
        const submissionId = row.rawData ? row.rawData.id : row.id;
        if (!submissionId) {
          this.$message.error("无法获取投稿ID");
          this.confirmVisible = false;
          return;
        }
        if (this.userInfo.is_member == false) {
          if (this.userInfo.submission_count === 0) {
            this.$message.warning("免费投稿次数已用完，请开通会员后继续投稿");
            this.confirmVisible = false;
            return;
          }
        }
        this.emailLoading = true;
        let flag = true;
        sendEmail({
          submission_id: submissionId,
        }).catch((error) => {
          this.$message.error(
            (error && error.message) || "投稿邮件发送失败，请稍后重试"
          );
          flag = false;
          this.fetchUserInfo();
          this.fetchSubmissionList();
        });
        setTimeout(() => {
          if (flag) {
            this.$message.success("投稿邮件发送中");
            this.confirmVisible = false;
            this.emailLoading = false;
            this.fetchUserInfo();
            this.fetchSubmissionList();
          }
        }, 5000);
      }
    },
    cancelConfirm() {
      this.confirmVisible = false;
      this.emailLoading = false;
    },
    closeFrequencyDialog() {
      this.frequencyDialogVisible = false;
      this.frequencyMinutes = "";
      this.frequencyTarget = null;
    },
    saveFrequency() {
      const n = Number(this.frequencyMinutes);
      if (!Number.isInteger(n) || n <= 0) {
        this.$message.warning("请输入大于 0 的整数分钟");
        return;
      }
      if (n > 5) {
        this.$message.warning("投稿频率不能超过 5 分钟");
        return;
      }
      const row = this.frequencyTarget;
      const submissionId = row && row.rawData ? row.rawData.id : row && row.id;
      if (!submissionId) {
        this.$message.error("无法获取投稿ID");
        return;
      }
      this.frequencyLoading = true;
      updateSendInterval({
        id: submissionId,
        mail_send_interval_minutes: String(n),
      })
        .then((response) => {
          this.$message.success("投稿频率设置成功");
          this.closeFrequencyDialog();
          // 频率设置后刷新页面列表，确保展示后端最新值
          this.fetchSubmissionList();
        })
        .catch((error) => {
          this.$message.error("设置失败，请稍后重试");
        })
        .finally(() => {
          this.frequencyLoading = false;
        });
    },
    headerCellStyle() {
      return {
        borderRight: "none",
        borderBottom: "1px solid #ebeef5",
        background: "#f7f7f9",
        color: "#333",
      };
    },
    bodyCellStyle() {
      return {
        borderRight: "none",
        borderBottom: "1px solid #f2f2f2",
      };
    },
    // 新建一条邮箱编辑项
    createEmailAuthItem() {
      return {
        id: null,
        email: "",
        auth_code: "",
        penName: "",
        isDefault: "0",
        weigh: 0,
      };
    },
    // 获取发件邮箱列表
    fetchSenderEmailList() {
      return getSenderEmailList()
        .then((response) => {
          const payload = response.data || {};
          const list = Array.isArray(payload.list)
            ? payload.list
            : Array.isArray(payload.data)
            ? payload.data
            : [];
          this.emailAuthList = list.map((item) => ({
            id: item.id,
            email: item.email || "",
            auth_code: item.auth_code || "",
            penName: item.pen_name || item.penName || "",
            isDefault: String(
              item.is_default === 1 || item.is_default === "1" ? 1 : 0
            ),
            weigh: item.weigh != null ? item.weigh : 0,
          }));

          if (this.emailAuthList.length === 0) {
            const first = this.createEmailAuthItem();
            first.isDefault = "1";
            this.emailAuthList = [first];
          } else if (
            !this.emailAuthList.some((item) => item.isDefault === "1")
          ) {
            this.emailAuthList[0].isDefault = "1";
          }
        })
        .catch((error) => {
          this.$message.error(error.message || "获取邮箱列表失败");
          this.emailAuthList = [];
        });
    },
    // 打开授权邮箱弹窗
    handleEmailCode() {
      this.emailAuthDialogVisible = true;
      this.fetchSenderEmailList();
    },
    // 关闭授权邮箱弹窗
    closeEmailAuthDialog() {
      this.emailAuthDialogVisible = false;
      this.emailAuthList = [];
      this.pendingSubmissionRow = null;
    },
    // 新增邮箱行（最多 3 条）
    addEmailAuthRow() {
      if (this.emailAuthList.length >= this.maxEmailCount) {
        this.$message.warning(`最多可设置 ${this.maxEmailCount} 个邮箱`);
        return;
      }
      const item = this.createEmailAuthItem();
      if (this.emailAuthList.length === 0) {
        item.isDefault = "1";
      }
      this.emailAuthList.push(item);
    },
    // 设置默认邮箱
    handleSetDefaultEmail(item) {
      if (!item) return;
      if (!item.id) {
        this.emailAuthList.forEach((row) => {
          row.isDefault = row === item ? "1" : "0";
        });
        return;
      }
      setDefaultSenderEmail({ id: item.id })
        .then(() => {
          this.$message.success("默认邮箱设置成功");
          this.fetchSenderEmailList();
        })
        .catch((error) => {
          this.$message.error(error.message || "设置默认邮箱失败");
        });
    },
    // 删除邮箱
    handleDeleteEmail(item, index) {
      if (!item || item.id == null) {
        this.emailAuthList.splice(index, 1);
        if (
          this.emailAuthList.length > 0 &&
          !this.emailAuthList.some((row) => row.isDefault === "1")
        ) {
          this.emailAuthList[0].isDefault = "1";
        }
        return;
      }
      deleteSenderEmail({ id: item.id })
        .then(() => {
          this.$message.success("删除成功");
          this.fetchSenderEmailList();
        })
        .catch((error) => {
          this.$message.error(error.message || "删除失败，请稍后重试");
        });
    },
    // 保存授权邮箱信息
    handleEmailAuthSave() {
      if (
        !Array.isArray(this.emailAuthList) ||
        this.emailAuthList.length === 0
      ) {
        this.$message.warning("请至少添加一个邮箱");
        return;
      }
      if (this.emailAuthList.length > this.maxEmailCount) {
        this.$message.warning(`最多可设置 ${this.maxEmailCount} 个邮箱`);
        return;
      }
      const hasDefault = this.emailAuthList.some(
        (item) => item.isDefault === "1"
      );
      if (!hasDefault) {
        this.$message.warning("请设置一个默认邮箱");
        return;
      }
      for (let i = 0; i < this.emailAuthList.length; i++) {
        const item = this.emailAuthList[i];
        if (!item.email) {
          this.$message.warning(`第 ${i + 1} 行请输入邮箱`);
          return;
        }
        if (!item.penName) {
          this.$message.warning(`第 ${i + 1} 行请输入笔名`);
          return;
        }
        if (!item.id && !item.auth_code) {
          this.$message.warning(`第 ${i + 1} 行请输入授权码`);
          return;
        }
      }

      this.emailAuthLoading = true;
      const tasks = this.emailAuthList.map((item, index) => {
        const payload = {
          email: item.email,
          auth_code: item.auth_code || "",
          pen_name: item.penName,
          is_default: item.isDefault,
          weigh:
            item.weigh != null ? item.weigh : this.emailAuthList.length - index,
        };
        return item.id
          ? editSenderEmail({
              ...payload,
              id: item.id,
            })
          : addSenderEmail(payload);
      });

      const pendingRow = this.pendingSubmissionRow;
      Promise.all(tasks)
        .then(() => {
          this.emailAuthLoading = false;
          this.$message.success("保存成功");
          this.closeEmailAuthDialog();
          // 刷新用户信息，获取最新的授权码状态
          this.fetchUserInfo().then(() => {
            // 如果有待投稿的记录，继续投稿流程
            if (pendingRow) {
              if (this.userInfo.is_member == false) {
                if (this.userInfo.submission_count === 0) {
                  this.$message.warning(
                    "免费投稿次数已用完，请开通会员后继续投稿"
                  );
                  this.pendingSubmissionRow = null;
                  return;
                }
              }
              this.confirmType = "start";
              this.confirmTarget = pendingRow;
              this.confirmVisible = true;
              this.pendingSubmissionRow = null;
            }
          });
        })
        .catch((error) => {
          this.emailAuthLoading = false;
          this.$message.error(error.message || "保存失败，请稍后重试");
        });
    },
    // 点击教程链接
    handleEmailAuthorizationCodeTutorial() {
      // 跳转到授权教程页面
      if (this.$router) {
        this.$router.push("/email-auth-tutorial");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.history-page {
  background: #fff6f8;
  min-height: 100vh;
}

.history-content {
  width: 1200px;
  margin: 20px auto;
}

.history-table {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #ebeef5;
}

.history-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0 0;
}

.history-table__header th {
  background: #f7f7f9 !important;
  color: #333;
  font-weight: 600;
}

.status-pill {
  padding: 4px 14px;
  border-radius: 14px;
  font-size: 13px;
}

.status-pill.success {
  color: #00cc0e;
}

.status-pill.pending {
  color: #ff383c;
}

.action-link {
  color: #d85a70;
  padding: 0 6px;
}

::v-deep .el-dialog {
  border-radius: 12px;
}

.history-dialog ::v-deep .el-dialog__header {
  border-bottom: none;
  text-align: center;
}

.history-dialog ::v-deep .el-dialog__body {
  text-align: center;
  font-size: 16px;
  color: #333;
}

::v-deep .frequency-dialog {
  height: 240px !important;

  .el-dialog__header {
    border-bottom: none;
    text-align: center;
  }

  .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 0;
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.dialog-btn {
  border-radius: 57px;
  width: 158px;
  height: 46px;
}

.dialog-btn.ghost {
  color: #d85a70;
  border-color: #d85a70;
}

.dialog-btn.solid {
  background: #d85a70;
}

.history-row {
  background: #fff;
}

/* 授权邮箱弹窗样式 */
::v-deep .email-auth-dialog {
  .el-dialog {
    border-radius: 12px;
    background: #f5f7fa;
  }

  .el-dialog__header {
    padding: 0;
    border-bottom: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__footer {
    padding: 0 0 30px 0;
    border-top: none;
  }
}

.email-auth-title {
  font-size: 18px;
  color: #212121;
  padding: 20px 0;
  font-weight: 600;
}

.email-auth-content {
  padding: 20px 30px;
}

.email-auth-tip {
  margin-bottom: 12px;
}

.email-auth-form {
  margin-bottom: 20px;
}

.email-auth-form-row {
  gap: 20px;
}

.email-auth-field {
  flex: 1;
}

.email-auth-label {
  white-space: nowrap;
}

.email-auth-actions {
  gap: 8px;
}

.email-auth-add-row {
  margin-top: 12px;
}

.email-auth-add-btn {
  border-color: #d85a70;
  color: #d85a70;
}

.email-auth-input {
  width: 100%;

  ::v-deep .el-input__inner {
    height: 40px;
    border-radius: 6px;
    border: 1px solid #dcdfe6;
    font-size: 14px;

    &:focus {
      border-color: #d85a70;
    }

    &::placeholder {
      font-size: 14px;
      color: #212121;
    }

    &::-webkit-input-placeholder {
      font-size: 14px;
      color: #212121;
    }

    &::-moz-placeholder {
      font-size: 14px;
      color: #212121;
    }

    &:-ms-input-placeholder {
      font-size: 14px;
      color: #212121;
    }
  }
}

.email-auth-footer {
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
}

.email-auth-save-btn {
  width: 345px;
  height: 46px;
  background: #d85a70;
  border-color: #d85a70;
  color: #fff;
  border-radius: 57px;
  font-size: 16px;
  font-weight: 500;

  &:hover {
    background: #c54a60;
    border-color: #c54a60;
  }

  &:active {
    background: #b83a50;
    border-color: #b83a50;
  }
}

.cursor-pointer {
  cursor: pointer;
}

::v-deep {
  .el-dialog {
    height: 549px;
    border-radius: 12px;
  }
}
</style>
